/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Col, FormGroup, FormFeedback, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

import Select from 'react-select';

import {AppContext} from '../AppContext';

class KeywordGroupModal extends React.Component 
{

  constructor(props) 
  {
    super();

    let description = (props.keywordGroup !== undefined ? props.keywordGroup.description : '');
    if (null === description) description = '';

    this.state = 
    {
      keywordGroup: (props.keywordGroup !== undefined ? props.keywordGroup.keywordGroup : ''),
      keywordGroupIsValid: undefined,
      description: description,
      createSaveDisabled: (props.keywordGroup ? false : true)
    }

    this.submitButtonHandler = this.submitButtonHandler.bind(this);
    this.updateKeywordGroup = this.updateKeywordGroup.bind(this);
    this.onSelectChangeHandler = this.onSelectChangeHandler.bind(this);
    this.setKeywordGroup = this.setKeywordGroup.bind(this);
    this.setDescription = this.setDescription.bind(this);
  }

  async createNewKeywordGroup()
  {
    var bodyData = {};

    bodyData.keywordGroup = this.state.keywordGroup;
    bodyData.description = this.state.description;

    let i = 0;
    let y = this.props.selectedObjectTypes.length;

    bodyData.objectTypeIds = [];
    for (i = 0; i < y; i++) bodyData.objectTypeIds[i] = this.props.selectedObjectTypes[i].objectTypeId;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'createKeywordGroup', bodyData);
    if ('success' !== result.status)
    {
      this.setState({createSaveDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error creating a keyword group');
    } 

    this.context.postNotification('info', 'New keyword group created.');
    this.props.closeModal();
    this.props.fetchKeywordGroups(this.state.keywordGroup);
  }

  onSelectChangeHandler(selectedOptions, actionMetaD)
  {
    this.props.setSelectedObjectTypes(selectedOptions);
  }

  render() 
  {
    let feedback = (this.state.keywordGroupIsValid ? null : 'You must provide a value for the keyword group name.');
    let createOrSave = ('create' === this.props.modalAction ? 'Create' : 'Save')
    let header = ('create' === this.props.modalAction ? 'Create a Keyword Group' : 'Edit a Keyword Group')

    return (
      <div>
        <Modal isOpen={this.props.modalIsOpen} autoFocus={false} >
          <ModalHeader toggle={this.props.closeModal}>{header}</ModalHeader>
          <ModalBody>
            <FormGroup row>
              <Label for="keywordGroup" sm="3">Group Name</Label>
              <Col sm="9">
                <Input type="text" id="keywordGroup" placeholder="Enter keyword group name" autoFocus
                  value={this.state.keywordGroup} onChange={this.setKeywordGroup}
                  invalid={(undefined === this.state.keywordGroupIsValid ? undefined : !this.state.keywordGroupIsValid)} 
                  valid={(undefined === this.state.keywordGroupIsValid ? undefined : this.state.keywordGroupIsValid)} 
                />
                <FormFeedback valid={false}>{feedback}</FormFeedback>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="description" sm="3">Description</Label>
              <Col sm="9">
                <Input type="text" id="description" placeholder="Enter a description (optional)" 
                  value={this.state.description} onChange={this.setDescription}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="objectTypeRestrictionComboBox" sm="3">File-Type Restrictions</Label>
              <Col sm="9">
                <Select value={this.props.selectedObjectTypes} defaultValue={this.props.selectedObjectTypes} options={this.props.objectTypes}
                  onChange={this.onSelectChangeHandler} isMulti
                  getOptionValue={option => option.objectTypeId} getOptionLabel={option => option.objectType} 
                  closeMenuOnSelect={false} placeholder={'Unrestricted...'} className="basic-multi-select" classNamePrefix="select"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col sm={{ size: 9, offset: 3 }}>
                <Button id="createKeywordGroupButton" onClick={this.submitButtonHandler} disabled={this.state.createSaveDisabled} 
                  color="primary">{createOrSave}</Button>
              </Col>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.props.closeModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  setDescription(event)
  {
    this.setState({description: event.target.value});
  }

  setKeywordGroup(event)
  {
    let valid =  ('' === event.target.value ? false : true);
    this.setState(
    {
      keywordGroup: event.target.value, 
      keywordGroupIsValid: valid,
      createSaveDisabled: !valid
    });
  }

  submitButtonHandler(event)
  {
    this.setState({createSaveDisabled: true});

    if ('create' === this.props.modalAction)
      this.createNewKeywordGroup();
    else
      this.updateKeywordGroup();
  }

  async updateKeywordGroup()
  {
    var bodyData = {};
    bodyData.keywordGroupId = this.props.keywordGroup.keywordGroupId;
    bodyData.keywordGroup = this.state.keywordGroup;
    bodyData.description = this.state.description;

    let i = 0;
    bodyData.objectTypeIds = [];

    if (null !== this.props.selectedObjectTypes)
    {
      for (i = 0; i < this.props.selectedObjectTypes.length; i++) 
        bodyData.objectTypeIds[i] = this.props.selectedObjectTypes[i].objectTypeId;
    }

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'updateKeywordGroup', bodyData);
    if ('success' !== result.status)
    {
      this.setState({createSaveDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, '');
    } 

    this.context.postNotification('info', 'Changes saved.');
    this.props.closeModal();
    this.props.fetchKeywordGroups();
  }
}

KeywordGroupModal.contextType = AppContext;

export default KeywordGroupModal